import React from 'react';
import {
  Box,
  Typography,
  useTheme,
  Tooltip,
  Divider
} from '@mui/material';
import { InfoIcon } from 'lucide-react';

import { Feeds as Feed } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-result.type';
import { FormattedNumber, useIntl } from 'react-intl';


const PAGE_NAME_ID = 'bluViuNutrition.viewScenarioResultGt2';
const ScenarioFeedTooltip: React.FC<{ feeds: Feed[], feedPlan: string, display: 'icon' | 'text' | 'both'; }> = ({ feeds, feedPlan, display }) => {
  const intl = useIntl();
  const theme = useTheme();
  return (
    <Tooltip
      placement={'top'}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 'none',
          },
        },
      }}
      title={
        <Box display={'inline-flex'} flexDirection={'column'} gap={2} width={'max-content'} maxWidth={'min(80vw, 560px)'}>
          <Box display={'grid'} gridTemplateColumns={'auto minmax(0, 1fr)'} columnGap={1}>
            <Typography fontWeight={'bold'} whiteSpace={'nowrap'}>
              {intl.formatMessage({ id: `${PAGE_NAME_ID}.tooltip.tooltipContent` })} -
            </Typography>
            <Typography style={{ overflowWrap: 'anywhere' }}>{feedPlan}</Typography>
          </Box>
          <Divider color={theme.palette.darkBlue.o50} />
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Typography>{intl.formatMessage({ id: `${PAGE_NAME_ID}.tooltip.feedsInProgram` })}</Typography>
            {feeds.length > 0 &&
              feeds.map((feed) => {
                return (
                  <Box key={`${feed.feedId}-${feed.fishSizeStart}`} display={'grid'} gridTemplateColumns={'auto minmax(0, 1fr)'} columnGap={2}>
                    <Typography fontWeight={'bold'} lineHeight={2}>
                      {<FormattedNumber value={feed.fishSizeStart} />}g
                    </Typography>
                    <Typography lineHeight={2} textAlign={'right'} style={{ overflowWrap: 'anywhere' }}>
                      {feed.feedName}
                    </Typography>
                  </Box>
                );
              })}
          </Box>
        </Box>
      }>
      <Box
        gap={4}
        minWidth={0}
        display={'flex'}
        overflow={'hidden'}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'flex-start'}>
        {display !== 'icon' && <Typography noWrap>{feedPlan}</Typography>}
        {display !== 'text' && <InfoIcon size={16} strokeWidth={3} style={{ flexShrink: 0 }} />}
      </Box>
    </Tooltip>
  )
}

export default ScenarioFeedTooltip;